'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('alignItems', 'align');


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/align-items.js
// module id = 4476
// module chunks = 168707334958949